interface GetEducationLinksParams {
  item: any;
}

const EducationalLinkParams = {
  urlId: 'url_id',
  url: 'url',
  affUnique3: 'aff_unique3',
};

export const getEducationLinks = ({ item }: GetEducationLinksParams): { viewOfferUrl?: URL; clickOfferUrl?: URL } => {
  const { advertising, link, hasOffersUrlId } = item;

  const paramsMap = {
    [EducationalLinkParams.urlId]: hasOffersUrlId,
    [EducationalLinkParams.url]: link,
    [EducationalLinkParams.affUnique3]: link,
  };

  try {
    const viewOfferUrl = new URL(advertising.monetization.pixels.display);
    const clickOfferUrl = new URL(advertising.monetization.pixels.click);

    const paramInLink = Object.values(EducationalLinkParams).find((param) => clickOfferUrl.searchParams.has(param));

    clickOfferUrl.searchParams.set(paramInLink, paramsMap[paramInLink]);
    viewOfferUrl.searchParams.set(paramInLink, paramsMap[paramInLink]);

    return {
      viewOfferUrl,
      clickOfferUrl,
    };
  } catch (error) {
    console.error(error);
  }
};
